import ReactExport from "@ibrahimrahmani/react-export-excel";

export const ExcelFile = ReactExport.ExcelFile;
export const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
export const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;